var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPipeline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  r: 2,
  transform: "matrix(-4.37114e-08 1 1 4.37114e-08 6 6)",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  r: 2,
  transform: "matrix(-4.37114e-08 1 1 4.37114e-08 18 18)",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 16L18 11C18 9.34315 16.6569 8 15 8V8C13.3431 8 12 9.34315 12 11L12 12",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 8L6 14C6 15.6569 7.34315 17 9 17V17C10.6569 17 12 15.6569 12 14L12 12",
  stroke: "currentColor",
  strokeWidth: 1.5
})));
export default SvgPipeline;